import { createUseStyles, multiply } from '@pushpay/styles';
export const headerHeight = '56px';
export const headerHeightMobile = '56px';
const sectionStyles = {
  height: '100%',
  display: 'flex',
  alignItems: 'center'
};
const useStyles = createUseStyles(theme => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.colors['color-background-surface'],
    color: theme.colors['color-text-default'],
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: headerHeight,
    zIndex: theme.ELEVATION.LAYOUT.Z_INDEX + 1,
    borderBottom: `1px solid ${theme.colors['color-border-surface']}`,
    [theme.mediaQuery({
      mediaType: 'PRINT'
    })]: {
      display: 'none'
    }
  },
  mobileMenuButtonWrapper: {
    // matches the height to make a square
    padding: `0 ${theme.SPACING.XSMALL}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  rightSide: { ...sectionStyles,
    justifyContent: 'flex-end',
    color: theme.colors['color-text-default'],
    padding: `0 ${theme.SPACING.SMALL}`,
    [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
      padding: `0 ${theme.SPACING.XSMALL}`
    }
  },
  toolBar: { ...sectionStyles,
    flex: '1 1 auto',
    justifyContent: 'flex-end',
    color: theme.colors['color-text-default'],
    [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
      paddingLeft: theme.SPACING.XSMALL,
      paddingRight: theme.SPACING.XSMALL
    }
  },
  leftSide: { ...sectionStyles,
    [theme.mediaBreakpoint('TABLET_AND_BELOW')]: {
      paddingLeft: 0
    }
  },
  logoWrapper: { ...sectionStyles,
    padding: `0 ${multiply(theme.SPACING.XSMALL, 1.5)}`
  }
}));
export default useStyles;